// Canonical bookmakers — the slugs that the api-tennis connector emits after
// normalize.ts maps the upstream vendor names. Keep this list in sync with
// `apps/workers/connector-api-tennis/src/normalize.ts` (BOOK_MAP). Sourcing
// from a single shared constant avoids drift between the connector and the
// admin UI's "Agregar casa" picker.
//
// `defaultType` is what gets pre-filled in the form when the operator picks
// from the canonical list. `sharp` books contribute to the market consensus
// (Pinnacle, Betfair Exchange); `soft` books only show as available cuotas.
// The operator can override the type per book afterwards.

export interface CanonicalBookmaker {
  slug: string;
  displayName: string;
  defaultType: 'sharp' | 'soft';
}

export const CANONICAL_BOOKMAKERS: readonly CanonicalBookmaker[] = [
  { slug: 'pinnacle', displayName: 'Pinnacle', defaultType: 'sharp' },
  { slug: 'betfair', displayName: 'Betfair Exchange', defaultType: 'sharp' },
  { slug: 'sbobet', displayName: 'SBObet', defaultType: 'soft' },
  { slug: 'bet365', displayName: 'Bet365', defaultType: 'soft' },
  { slug: 'bwin', displayName: 'Bwin', defaultType: 'soft' },
  { slug: 'betano', displayName: 'Betano', defaultType: 'soft' },
  { slug: 'unibet', displayName: 'Unibet', defaultType: 'soft' },
  { slug: '1xbet', displayName: '1xBet', defaultType: 'soft' },
  { slug: 'marathon', displayName: 'Marathon', defaultType: 'soft' },
  { slug: '10bet', displayName: '10Bet', defaultType: 'soft' },
] as const;

export function findCanonicalBookmaker(slug: string): CanonicalBookmaker | null {
  const norm = slug.trim().toLowerCase();
  return CANONICAL_BOOKMAKERS.find((b) => b.slug === norm) ?? null;
}
